import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PartnerWidget } from "./components/PartnerWidget";
import { WaitlistPage } from "./components/WaitlistPage";
import WaitlistFormWidget from "./components/WaitlistFormWidget";
import WaitlistFormWidgetV2 from "./components/WaitlistFormWidgetV2";
import DocumentationPage from "./components/DocumentationPage";
import MarketingAgencyPage from "./components/MarketingAgencyPage";
import MarketingFormWidget from "./components/MarketingFormWidget";
import EthosContractingForm from "./components/EthosContractingForm";
import EmbedPage from "./pages/EmbedPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Default landing page redirects to admin */}
            <Route path="/" element={<Navigate to="/admin/login" replace />} />
            <Route path="/partner" element={<PartnerWidget />} />
            <Route path="/embed" element={<EmbedPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/waitlist/embed" element={<WaitlistFormWidget />} />
            <Route path="/waitlist/embed/v2" element={<WaitlistFormWidgetV2 />} />
            <Route path="/docs" element={<DocumentationPage />} />
            <Route path="/marketing" element={<MarketingAgencyPage />} />
            <Route path="/marketing/embed" element={<MarketingFormWidget />} />
            {/* Contracting routes */}
            <Route path="/contracting/ethos/apply" element={<EthosContractingForm />} />
            <Route path="/contracting/ethos/apply/" element={<EthosContractingForm />} />
            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/submissions" element={<Navigate to="/admin" replace />} />
            {/* Redirect old sitemap to admin */}
            <Route path="/sitemap" element={<Navigate to="/admin" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
